<template>
    <div class="hf-form-ui-form"  >
<!--完整表单-->

        <component v-if="loadSuccess"
                   v-bind:is="'FormUiForm'"
                   ref="FormUiForm"
                   v-bind:removeFileds="removeFields"
                   v-bind:ruleFormSrc="ruleForm"
                   v-bind:beanName="simpleFormResp.beanName"
                   @submitForm="submitFormObj"

        ></component>

    </div>
</template>

<script>

  import FormUiForm from './FormUiForm.vue'
  import formuiService from './service/formui/FormuiService.js'
  import httpUtil from './service/base/httpUtil.js'


export default {
  name: 'FormUiSimpleForm',
    props: ['simpleFormName'],
    components:{FormUiForm},
    data () {
    return {
        loadSuccess:false,
        ruleForm:{},
        simpleFormResp:{},
        removeFields:''
    }
  },

  methods: {


    // 提交
      submitFormObj (formObj) {

      let that = this

          if(that.simpleFormResp.method=='POST'){
              httpUtil.httpPost(that,that.simpleFormResp.url, formObj,function (res) {
                  that.$emit('submitCallback', res)
//                  callback(res)
              },function (err) {
                  console.log('err get' + err)
                  if(error){
                      error(err)
                  }
              })
          }else if(that.simpleFormResp.method=='GET'){
              alert('暂不支持get');
          }else if(that.simpleFormResp.method=='PUT'){
              httpUtil.httpPut(that,that.simpleFormResp.url, formObj,function (res) {
                  that.$emit('submitCallback', res)
              },function (err) {
                  console.log('err get' + err)
                  if(error){
                      error(err)
                  }
              })
          }else if(that.simpleFormResp.method=='DELETE'){
            alert('暂不支持delete');
          }

    },

  },

  created () {
//      console.log('-----------simplefrom demo-------------')
      let that=this
//      that.loadSuccess=true

      let params={}
      params.methodName=this.simpleFormName;

      if(that.$route.query.id){
          params.id=that.$route.query.id
      }

      formuiService.getSimpleForm(this,params,function (resp) {
        that.simpleFormResp=resp
          that.removeFields=resp.removeFields.split(',')
//          console.log(resp.dataObjage)
//         let keyss= Object.keys(resp.dataObj)
//          console.log(keyss)
          if(resp.dataObj){
              that.ruleForm=resp.dataObj
          }else{
              that.ruleForm={}
              for (var name in that.$route.query) {
//                    alert(name+'_____'+that.$route.query[name])
                  if (that.$route.query[name] || that.$route.query[name] === '' || that.$route.query[name] === 0) {
//                      alert(0)
                      if (Date.parse(that.$route.query[name]).toString() != 'NaN') {
                          that.ruleForm[name] = that.$route.query[name]
//                          alert(1)
                      }  else if (parseFloat(that.$route.query[name]).toString() != 'NaN') {
                          that.ruleForm[name] = parseFloat(that.$route.query[name])
//                          alert(name)
                      } else if (that.$route.query[name].indexOf(',') != -1) {
                          that.ruleForm[name] = that.$route.query[name]
                      } else {
                          that.ruleForm[name] = that.$route.query[name]
                      }
                  }
              }


//              alert(that.ruleForm['name'])
          }


          that.loadSuccess=true
      })
//      alert(this.simpleFormName)
//      alert(11)

  },

  updated () {
//    console.log('-----------updated-------------')
  },

  mounted () {
//      alert(22)
  }
}
</script>

<style scoped>

</style>



// WEBPACK FOOTER //
// node_modules/formui-vue2-vistastory/FormUiSimpleForm.vue